import { apiFetch } from '@/lib/api';

export class AccountService {
  async getProfile() {
    const res = await apiFetch('/api/account/profile');
    if (!res.ok) throw new Error('Failed to load profile');
    const data = await res.json();
    return data.data as { id: string; email: string; fullName: string; avatarUrl?: string | null; isEmailVerified: boolean; createdAt: string };
  }

  async updateProfile(input: { fullName?: string; avatarUrl?: string }) {
    const res = await apiFetch('/api/account/profile', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error('Failed to update profile');
    const data = await res.json();
    return data.data;
  }

  async changePassword(input: { currentPassword: string; newPassword: string }) {
    const res = await apiFetch('/api/account/password', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
      skipRefresh: true,
    });
    if (!res.ok) throw new Error('Failed to change password');
  }

  async startEmailChange(newEmail: string) {
    const res = await apiFetch('/api/account/email/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newEmail }),
      skipRefresh: true,
    });
    if (!res.ok) throw new Error('Failed to start email change');
    return;
  }

  async confirmEmailChange(token: string) {
    const res = await apiFetch('/api/account/email/confirm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
      skipRefresh: true,
    });
    if (!res.ok) throw new Error('Failed to confirm email change');
    const data = await res.json();
    return data.data;
  }

  async listSessions() {
    const res = await apiFetch('/api/account/sessions');
    if (!res.ok) throw new Error('Failed to load sessions');
    const data = await res.json();
    return data.data as Array<{ id: string; user_agent: string | null; ip: string | null; created_at: string; expires_at: string; revoked_at: string | null }>;
  }

  async revokeSession(id: string) {
    const res = await apiFetch(`/api/account/sessions/${encodeURIComponent(id)}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to revoke session');
  }

  async revokeOtherSessions() {
    const res = await apiFetch('/api/account/sessions/others', { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to revoke other sessions');
  }
}


